// Size-limited cache for API responses (exchanges, markets, stocks,
// per-market TradingView prefixes), shared by all fetchers in App.js.
export const CACHE_SIZE_LIMIT = 50;
export const CACHE_EXPIRY_TIME = 5 * 60 * 1000; // 5 minutes

export class Cache {
  constructor() {
    this.cache = new Map();
  }

  set(key, value) {
    // Refreshing an existing key must not evict anything, even at capacity.
    const isRefresh = this.cache.has(key);
    if (!isRefresh && this.cache.size >= CACHE_SIZE_LIMIT) {
      // Remove the oldest entry
      const oldestKey = this.cache.keys().next().value;
      this.cache.delete(oldestKey);
    }
    this.cache.set(key, { value, timestamp: Date.now() });
  }

  get(key) {
    const entry = this.cache.get(key);
    if (entry) {
      if (Date.now() - entry.timestamp > CACHE_EXPIRY_TIME) {
        this.cache.delete(key); // Remove expired
        return null;
      }
      return entry.value;
    }
    return null;
  }
}
